<template>
  <div class="order-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('order_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon  large>mdi-basket</v-icon>
            {{$t('order.orders')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <OrderFilterForm
                ref="filterForm"
                :values="filters"
                slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              :items-per-page.sync="options.itemsPerPage"
              :footer-props="footer"
              :loading="isLoading"
              :loading-text="$t('global.loading')"
              :options.sync="options"
              :server-items-length="totalItems"
              class="elevation-1"
              item-key="@id"
              @click:row="showHandler"
              @contextmenu:row="showHandlerExt"
              @update:options="onUpdateOptions"
          >
            <!-- Template du bage de couleur -->
            <template slot="item.badge" slot-scope="{ item }">
              <v-tooltip bottom content-class="tooltip-light">
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" class="ma-0 pa-0">
                    <v-badge inline center overlap dark v-bind="attrs"
                    :color="item.state.couleur">
                    </v-badge>
                  </div>
                </template>
                <span>{{item.state.name}}</span>
              </v-tooltip>
            </template>

            <template slot="item.material.name" slot-scope="{item}" >
              <span class="truncate-material">{{ item.material ? item.material.name : '' }}</span>
            </template>

            <template slot="item.customer.name" slot-scope="{item}" >
              <span class="truncate">{{ item.customer ? item.customer.name : '' }}</span>
            </template>

            <template slot="item.delivery" slot-scope="{ item }">
              <span class="truncate">{{ formatDate(item['delivery'], 'long') }}</span>
            </template>

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import OrderFilterForm from '../../components/order/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'OrderList',
  servicePrefix: 'Order',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    OrderFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('order.state_'),value:'badge'},
        { text: this.$t('order.id'), value: 'id' },
        { text: this.$t('order.ref'), value: 'ref' },
        { text: this.$t('customer.customer'), value: 'customer.name' },
        { text: this.$t('order.quantity'), value: 'quantity' },
        { text: this.$t('order.material'), value: 'material.name' },
        { text: this.$t('priority.priority'), value: 'priority.name' },
        { text: this.$t('order.delivery_short'), value: 'delivery' },
        
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['created'], sortDesc : [true]},
    };
  },
  computed: {
    ...mapGetters('order', {
      items: 'list'
    }),
    ...mapFields('order', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    getInitials(str) {
      const splitStr = str.split(/[\s.]/);
      let initials = '';
      splitStr.forEach(word => {
        if (word) {
          initials += word.charAt(0).toUpperCase() + '.';
        }
      });
      return initials.slice(0, -1);
    },
    ...mapActions('order', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
  },
  mounted() {
  },
};
</script>
<style>
    .truncate {
      max-width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
    }
    .truncate-material {
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
    }
    .tooltip-light {
  background-color: white;
  color: black;
}

</style>
